var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../BlocksElement';
import '../button/button';
import styles from './pagination-item.styles';
/**
 * @slot default - The component content
 * @csspart base - The component's base wrapper.
 * @csspart link - The component's link.
 * @csspart part-default - The component's default slot.
 */
export class BlocksPaginationItem extends BlocksElement {
    static { this.styles = styles; }
    focus(options) {
        this.paginationItemButton.focus(options);
    }
    render() {
        const componentClassNames = this.componentClassNames('cat-c-pagination__item', {
            'cat-is-active': this.isActive === true
        });
        return html `
      <li part="base" class="${componentClassNames}">
        ${this.navigationType !== 'ellipsis'
            ? html ` <cat-button
              part="pagination-item-button"
              variant="ghost"
              size="sm"
              ?disabled=${this.disabled}
              label=${ifDefined(this.arialabel)}
              role="presentation"
              ?currentStateIndicator=${this.isActive}
              class="cat-c-pagination__item-button"
            >
              <slot part="part-default"></slot>
            </cat-button>`
            : html `<slot part="part-default"></slot>`}
      </li>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksPaginationItem.prototype, "text", void 0);
__decorate([
    property({ type: Boolean })
], BlocksPaginationItem.prototype, "divide", void 0);
__decorate([
    property({ type: Boolean })
], BlocksPaginationItem.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], BlocksPaginationItem.prototype, "isActive", void 0);
__decorate([
    property({ type: String })
], BlocksPaginationItem.prototype, "arialabel", void 0);
__decorate([
    property({ type: String })
], BlocksPaginationItem.prototype, "navigationType", void 0);
__decorate([
    query('.cat-c-pagination__item-button')
], BlocksPaginationItem.prototype, "paginationItemButton", void 0);
if (customElements.get('cat-pagination-item') === undefined) {
    customElements.define('cat-pagination-item', BlocksPaginationItem);
}
